import { render } from "./TwitchToken.vue?vue&type=template&id=20c0e08e"
import script from "./TwitchToken.vue?vue&type=script&lang=js"
export * from "./TwitchToken.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__